<script>            
    import Login from './Login.svelte'
    import Progress from '../components/Progress.svelte'
    import {auth,authenticated} from '../service'        
    import {language, locale} from '../languages.js'
    import {register as registerUser} from '../service'
        
    export let show_translation_btn = true
    export let hide_forget_link = true
    export let disable_guest_login = true
    
    
    let pending = false;
    let errorMessage = null;
    let showRegisterForm = false
    
    let validate = (credentials)=>{return credentials.username && credentials.password}    
    function  login(e){
        let credentials = e.detail
        
        if(validate(credentials))
        {
            pending = true
            auth(credentials.username,credentials.password)
            .then(resp => {                 
                pending = false
                errorMessage = null
            }).catch((error) =>{
                pending = false                
          
                if(error.status == 401) {                    
                     errorMessage = $language.error_message_unauthorized
                } else{
                    if(error.status == 409){
                        errorMessage = $language.error_message_already_loggedin
                    }
                    else{ 
                        errorMessage = $language.error_message_server_error 
                    }
                }

            })                
        }
    }
  
    function register(e){
        let data = e.detail        
        pending = true
        registerUser(data)
        .then(resp=>{
            pending = false
            errorMessage = null
            console.log(resp.status)
            if(resp.status == 400){
                showRegisterForm = true                
                resp.json().then((x)=>{   
                    console.log({x})                 
                    errorMessage = x.detail[$locale]
                })
                .catch((e)=>{
                        console.log({e})
                    })
            }
            if(resp.status == 200){
                showRegisterForm = false
            }
            
        }).catch((err)=>{
            showRegisterForm = true
            console.log(err)
            errorMessage = err.message || "خطأ غير محدد"
        })


    }  
</script>
{#if $authenticated} 
    <slot/>
{:else}
    {#if !pending }              
        <Login on:login={login} on:register={register} {showRegisterForm} {errorMessage} {show_translation_btn} {hide_forget_link} {disable_guest_login}/>
    {:else }
            <div class="w-screen h-screen bg-green-600 flex flex-col justify-center">
                 <div class="w-full flex flex-row justify-center">
                        <Progress size={100} class="text-white" />
                </div>
            </div>
    {/if}    
{/if}    


